module.exports = __webpack_public_path__ + "img/default-avatar-001.c88ee20b.png";